import {
  AUTH_INACTIVITY_LIMIT_MS,
  AUTH_SESSION_STORAGE_KEY,
  AUTH_STORAGE_KEY,
} from "../constants/auth";

export function isSessionActive(session) {
  return Boolean(
    session?.accessToken &&
      session?.expiresAt &&
      Number(session.expiresAt) > Date.now(),
  );
}

export function isTvLiveDashboardSession(session) {
  if (typeof window === "undefined") {
    return false;
  }

  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  const username = String(session?.username || "").trim().toLowerCase();
  const currentHour = new Date().getHours();

  return (
    pathname === "/live-dashboard" &&
    username === "tv" &&
    currentHour >= 10 &&
    currentHour < 19
  );
}

export function getStoredAuthSession() {
  const savedSession = localStorage.getItem(AUTH_SESSION_STORAGE_KEY);

  if (!savedSession) {
    return null;
  }

  try {
    const session = JSON.parse(savedSession);

    if (!session?.accessToken || !session?.username) {
      clearAuthState();
      return null;
    }

    return session;
  } catch {
    clearAuthState();
    return null;
  }
}

export function getSavedAuthState() {
  const session = getSavedAuthSession();

  return Boolean(
    isSessionActive(session) ||
      (session?.refreshToken &&
        (isUserActive(session) || isTvLiveDashboardSession(session))),
  );
}

export function getSavedAuthSession() {
  const session = getStoredAuthSession();

  if (
    session &&
    !isSessionActive(session) &&
    (!session.refreshToken ||
      (!isUserActive(session) && !isTvLiveDashboardSession(session)))
  ) {
    clearAuthState();
    return null;
  }

  return session;
}

export function saveAuthState(session) {
  if (session) {
    localStorage.setItem(
      AUTH_SESSION_STORAGE_KEY,
      JSON.stringify({
        ...session,
        lastActivityAt: session.lastActivityAt || Date.now(),
      }),
    );
  }

  localStorage.setItem(AUTH_STORAGE_KEY, "true");
}

export function clearAuthState() {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEY);
}

export function getSavedAccessToken() {
  return getSavedAuthSession()?.accessToken || null;
}

export function isUserActive(session, now = Date.now()) {
  return Boolean(
    session?.lastActivityAt &&
      now - Number(session.lastActivityAt) <= AUTH_INACTIVITY_LIMIT_MS,
  );
}

export function recordUserActivity(now = Date.now()) {
  const session = getSavedAuthSession();

  if (!session) {
    return null;
  }

  const nextSession = { ...session, lastActivityAt: now };
  saveAuthState(nextSession);
  return nextSession;
}

export function getSavedAuthUser() {
  return getSavedAuthSession()?.user || null;
}
